angular.module('dnecom')
    .controller('SEOConfigurationModal', ["$scope", "$uibModalInstance", "seo", function SEOConfigurationModal($scope, $uibModalInstance, seo){
        $scope.seo = seo;

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.save = function () {
            $uibModalInstance.close($scope.seo);
        };
    }]);
